import React from 'react';
import { BusinessIcon, Divider, Text } from '@billda/design-system';
import { PermissionGate } from '../../../shared/components/gates/PermissionGate';
import { Permissions, usePermission } from '@billda/permissions-ui';
import { CompanyDetailsForm } from '../../../features/organisation/components/CompanyDetailsForm';

/**
 * Organisation settings area: company details for invoices.
 */
export const OrganisationArea: React.FC = () => {
  const canManage = usePermission(Permissions.Organisation.Details.Manage);

  return (
    <PermissionGate
      permission={Permissions.Organisation.Details.Read}
      showRequiredPermissions={false}
    >
      <div
        className="mb-6 rounded-xl border border-border-default bg-surface-default p-6"
        data-testid="organisation-section"
      >
        <div className="mb-4 flex items-center">
          <BusinessIcon
            aria-hidden="true"
            className="mr-2 size-5 text-content-accent"
          />
          <Text variant="h6">Organisation</Text>
        </div>

        <Text as="div" variant="body2" color="secondary" className="mb-6">
          {canManage
            ? "Manage your organisation's company details for invoices."
            : "Your organisation's company details used for invoices."}
        </Text>

        <Divider className="mb-6" />

        <CompanyDetailsForm readOnly={!canManage} />
      </div>
    </PermissionGate>
  );
};
